module.exports = __webpack_public_path__ + "img/4.c91792e9.png";